import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4ae1c00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://beian.miit.gov.cn/",
    target: "_blank"
  }, "蜀ICP备2023001343号")
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import Menu from "./Menu.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})